import { useState } from "react";
import { Download } from "lucide-react";
import { api, apiError } from "../lib/api";
import { toast } from "sonner";

/**
 * ExportCsvBtn - drops onto any list view. Fetches
 * `${REACT_APP_BACKEND_URL}/api/export/${resource}.csv` as a blob, triggers a
 * client-side download, and toasts on failure. The resource must be one of the
 * whitelisted keys on the backend (clients, appointments, progress_notes,
 * assessments, consent_forms, tasks). The download is audit-logged server-side.
 */
export function ExportCsvBtn({ resource, label = "Export CSV", filename, className = "", ...rest }) {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const r = await api.get(`/export/${resource}.csv`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([r.data], { type: "text/csv" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = filename || `${resource}_${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 5000);
      toast.success(`${resource} exported`);
    } catch (err) { toast.error(apiError(err)); }
    setBusy(false);
  };
  return (
    <button type="button" onClick={download} disabled={busy}
      data-testid={`export-${resource}-csv-btn`}
      className={`inline-flex items-center gap-1.5 rounded-full border border-[#D7CCC8] bg-white px-3.5 py-1.5 text-xs font-semibold text-[#4E342E] hover:bg-[#F5F2EB] disabled:opacity-60 ${className}`}
      {...rest}>
      <Download size={13} /> {busy ? "Exporting…" : label}
    </button>
  );
}
